module.exports = __webpack_public_path__ + "img/checkbox-default-light.4275912.svg";